import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const categories = ['All', 'Weddings', 'Corporate', 'Social & Private'];
export const portfolioItems = [{
  id: 1,
  category: 'Social & Private',
  title: 'Red Roses Birthday Lux Event',
  mediaType: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/t56AP9tMtyGmTaR1jdHNXe/Red%20Roses%20Birthday%20Lux%20Event.mp4',
  poster: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=800',
  description: 'A luxurious birthday celebration featuring stunning red rose floral arrangements, elegant table settings, and a custom curated menu designed to delight every guest.',
  gallery: ['https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 2,
  category: 'Corporate',
  title: "Women's Caucus Brunch Set-up",
  mediaType: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/rtaX1BcQNKEW21Dp7G6hLa/Women%E2%80%99s%20Caucus%20Brunch%20Set-up.mp4',
  poster: 'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&q=80&w=800',
  description: "A sophisticated and empowering brunch setup for the Women's Caucus. We provided a seamless catering experience with a focus on fresh, vibrant ingredients and flawless presentation.",
  gallery: ['https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 3,
  category: 'Social & Private',
  title: 'Graduation Catering Party',
  mediaType: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/tWeER3SAVhy5L91uejKwKb/Graduation%20Catering%20Party.mp4',
  poster: 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?auto=format&fit=crop&q=80&w=800',
  description: 'Celebrating academic achievements with a vibrant and fun catering setup. Featuring interactive food stations, customized desserts, and a lively atmosphere.',
  gallery: ['https://images.unsplash.com/photo-1530103862676-de8892b07439?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 4,
  category: 'Weddings',
  title: 'Elegant Wedding Reception',
  mediaType: 'image',
  src: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=1200',
  description: "A breathtaking wedding reception where every detail was meticulously planned. From the grand buffet to the signature cocktails, we ensured the couple's special day was unforgettable.",
  gallery: ['https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 5,
  category: 'Social & Private',
  title: 'Lavender Picnic Setup',
  mediaType: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/i1yaQ7rhDn8zXPcCiik1U9/Lavender_Picnic(1).jpg',
  description: 'An intimate, beautifully styled outdoor picnic featuring lavender accents, artisanal charcuterie, and refreshing beverages for a perfect afternoon gathering.',
  gallery: ['https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 6,
  category: 'Corporate',
  title: 'Executive Luncheon',
  mediaType: 'image',
  src: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=1200',
  description: 'A high-end corporate luncheon designed to impress clients and executives. We provided a seamless, professional service with a gourmet menu tailored to dietary preferences.',
  gallery: ['https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 7,
  category: 'Weddings',
  title: 'Intimate Bridal Shower',
  mediaType: 'image',
  src: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?auto=format&fit=crop&q=80&w=1200',
  description: 'A delicate and beautiful bridal shower featuring elegant canapés, a mimosa bar, and stunning floral arrangements to celebrate the bride-to-be.',
  gallery: ['https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&q=80&w=1200']
}, {
  id: 8,
  category: 'Social & Private',
  title: 'Community Gala',
  mediaType: 'image',
  src: 'https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=1200',
  description: 'A large-scale community gala where we managed full-service catering for hundreds of guests, ensuring hot, delicious meals and impeccable service throughout the evening.',
  gallery: ['https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=1200']
}];
export function OurEvents({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  const [activeCategory, setActiveCategory] = useState('All');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const filteredItems = portfolioItems.filter(item => activeCategory === 'All' || item.category === activeCategory);
  return <div className="bg-white min-h-screen pt-24" data-id="element-578">
      {/* Header Section */}
      <section className="py-16 md:py-20 bg-brand-black text-white relative overflow-hidden" data-id="element-579">
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center mix-blend-overlay" data-id="element-580" />
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center" data-id="element-581">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-582">
            <span className="text-brand-gold font-bold tracking-[0.3em] uppercase text-xs mb-4 block" data-id="element-583">
              Portfolio
            </span>
            <h1 className="text-4xl md:text-6xl font-serif mb-6" data-id="element-584">Our Events</h1>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-585">
              Explore our gallery of past events. From intimate private
              gatherings to grand weddings and corporate functions, see how we
              bring culinary visions to life.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 md:py-24 max-w-7xl mx-auto px-6" data-id="element-586">
        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-16" data-id="element-587">
          {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-6 py-2 rounded-full text-sm font-bold uppercase tracking-widest transition-all duration-300 ${activeCategory === category ? 'bg-brand-black text-white' : 'bg-gray-100 text-gray-500 hover:bg-brand-gold hover:text-white'}`} data-id="element-588">
              {category}
            </button>)}
        </div>

        {/* Grid */}
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-589">
          <AnimatePresence data-id="element-590">
            {filteredItems.map(item => <motion.div key={item.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4
          }} className="group relative aspect-[4/5] overflow-hidden rounded-sm bg-gray-100 shadow-md" data-id="element-591">
                <Link to={`/events/${item.id}`} className="block w-full h-full" data-id="element-592">
                  {item.mediaType === 'video' ? <video autoPlay muted loop playsInline poster={item.poster} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-593">
                      <source src={item.src} type="video/mp4" data-id="element-594" />
                    </video> : <img src={item.src} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-595" />}

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-black/90 via-brand-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-8" data-id="element-596">
                    {item.mediaType === 'video' && <div className="absolute top-6 right-6 w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-597">
                        <Play size={16} fill="currentColor" data-id="element-598" />
                      </div>}
                    <span className="text-brand-gold text-xs font-bold uppercase tracking-widest mb-2 block transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-599">
                      {item.category}
                    </span>
                    <h3 className="text-white text-2xl font-serif transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75" data-id="element-600">
                      {item.title}
                    </h3>
                  </div>
                </Link>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {filteredItems.length === 0 && <div className="text-center py-20 text-gray-500" data-id="element-601">
            No events found for this category.
          </div>}
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50 text-center px-6" data-id="element-602">
        <div className="max-w-3xl mx-auto" data-id="element-603">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-brand-black" data-id="element-604">
            Ready to Plan Your Event?
          </h2>
          <p className="text-gray-600 text-lg mb-10" data-id="element-605">
            Let us bring our expertise, passion, and exquisite flavors to your
            next gathering.
          </p>
          <button onClick={() => openQuote()} className="bg-brand-gold text-white px-10 py-5 rounded-sm text-sm font-bold uppercase tracking-widest hover:bg-brand-black transition-all duration-300 shadow-xl inline-flex items-center gap-3" data-id="element-606">
            Request a Quote <ArrowRight size={18} data-id="element-607" />
          </button>
        </div>
      </section>
    </div>;
}